// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import Admin__CategoryEditorController from "./admin/category_editor_controller"
application.register("admin--category-editor", Admin__CategoryEditorController)

import Admin__CategorySelectController from "./admin/category_select_controller"
application.register("admin--category-select", Admin__CategorySelectController)

import Admin__SiteCategoriesController from "./admin/site_categories_controller"
application.register("admin--site-categories", Admin__SiteCategoriesController)

import Admin__SiteCategoryEditor__FormController from "./admin/site_category_editor/form_controller"
application.register("admin--site-category-editor--form", Admin__SiteCategoryEditor__FormController)

import Admin__SiteCategoryEditorController from "./admin/site_category_editor_controller"
application.register("admin--site-category-editor", Admin__SiteCategoryEditorController)

import AnchorController from "./anchor_controller"
application.register("anchor", AnchorController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import HeaderCategoriesController from "./header_categories_controller"
application.register("header-categories", HeaderCategoriesController)

import Item__DeliveryDateSelectController from "./item/delivery_date_select_controller"
application.register("item--delivery-date-select", Item__DeliveryDateSelectController)

import Item__FavoriteButtonController from "./item/favorite_button_controller"
application.register("item--favorite-button", Item__FavoriteButtonController)

import Item__MenuController from "./item/menu_controller"
application.register("item--menu", Item__MenuController)

import ItemController from "./item_controller"
application.register("item", ItemController)

import KeywordSearch__AutocompleteController from "./keyword_search/autocomplete_controller"
application.register("keyword-search--autocomplete", KeywordSearch__AutocompleteController)

import ResizeObserverController from "./resize_observer_controller"
application.register("resize-observer", ResizeObserverController)

import SearchFieldController from "./search_field_controller"
application.register("search-field", SearchFieldController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import SubLinksController from "./sub_links_controller"
application.register("sub-links", SubLinksController)

import TrackingTagsController from "./tracking_tags_controller"
application.register("tracking-tags", TrackingTagsController)

import ViewportController from "./viewport_controller"
application.register("viewport", ViewportController)
